import React from "react"
import styled from "styled-components"
import Page from "../common/page"
import Banner from "../common/banner"
import RecipeBox from "../recipes/recipe-box"
import ItemsCarousel from "../common/items-carousel"
import SEO from "../seo"
import {
  contentfulLanguage,
  getLanguage,
  getTranslation,
  isSubdomain,
} from "../../utils"

const StyledHomepage = styled.div`
  margin-bottom: 2rem;

  @media (min-width: 1024px) {
    margin-bottom: 4rem;
  }

  .container {
    > div:last-child {
      margin-top: 1rem;

      @media (min-width: 769px) {
        margin-top: 4rem;
      }
    }
  }
`

const StyledRecipesList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin: 0;
  padding: 2rem 0 0;

  + div {
    margin-top: 0 !important;
  }
`

const IndexPage = props => {
  const pageData = props.pageContext.pageData
  if (!pageData) return null

  const multiCookers = []
  const slowCookers = []

  if (props.pageContext.products) {
    props.pageContext.products.forEach(({ node }) => {
      const formattedLanguage = isSubdomain()
        ? isSubdomain()
        : contentfulLanguage(getLanguage().split("/")[1])

      if (node.localeT?.indexOf(formattedLanguage) > -1) {
        if (node.category === "Slow Cookers") {
          slowCookers.push(node)
        } else {
          multiCookers.push(node)
        }
      }
    })
  }

  return (
    <StyledHomepage>
      <Page page={pageData}>
        {slowCookers.length > 0 && (
          <ItemsCarousel
            items={slowCookers}
            title={getTranslation("slow-cookers")}
            hasLine={true}
            showRatings={props?.pageContext?.isEn}
          />
        )}

        {multiCookers.length > 0 && (
          <ItemsCarousel
            items={multiCookers}
            title={getTranslation("multi-cookers")}
            hasLine={true}
            showRatings={props?.pageContext?.isEn}
          />
        )}

        {pageData.recipes && (
          <StyledRecipesList>
            {pageData.recipes.map(item => {
              return <RecipeBox recipe={item} key={item.contentful_id} />
            })}
            <RecipeBox
              isAll={true}
              image={pageData.allRecipesImage.gatsbyImageData}
              title={pageData.allRecipesText}
              key="1"
            />
          </StyledRecipesList>
        )}

        {pageData.video?.url && <Banner videoFile={pageData.video?.url} />}
      </Page>
    </StyledHomepage>
  )
}

export default IndexPage

export const Head = ({ location, pageContext }) => (
  <SEO
    pathname={location.pathname}
    showRatings={pageContext.isEn}
    pageContext={pageContext}
  />
)
